export default {
	section_main_banner: {
		title: {
			one: '暗号資産で取引を強化',
			two: '',
			three: '',
			four: '',
			five: '',
			six: '',
		},
		description: {
			one: '当社のプラットフォームでは、暗号資産を交換する必',
			two: '要がなく、瞬時にシームレスに支払いを行うことが',
			three: 'できます。これにより、スピード、セキュリティ、',
			four: '利便性が確保されます。',
		},
		cta_buttons: {
			one: '暗号資産で即時決済',
		},
	},
	section_safety_speed: {
		cards: {
			one: {
				title: '安全性とスピードを同時に',
				description: {
					one: 'ブロックチェーン技術の実証済みの安定性と、',
					two: 'これまでにないスピード、セキュリティ、シーム',
					three: 'レスな取引を実現する JP WOLRD PAY 独自のプラットフォームの',
					four: 'イノベーションを組み合わせた、',
					five: '最速かつ最も信頼性の高い決済システムを体験してください。',
				},
			},
			two: {
				title: '無料登録',
				description: {
					one: 'メールアドレスとビジネスに関する',
					two: '基本的な情報だけが必要です。',
				},
			},
			three: {
				title: '支払い開始',
				description: {
					one: 'メールを確認し、会社名を入力し、',
					two: 'アカウントをリンクすれば、',
					three: '販売準備が完了します。',
				},
			},
		},
		title: 'JP WORLD PAYの安全性とスピード',
		cta_button: '会員登録',
	},
	section_use: {
		title: '誰でも簡単に利用できるJP WOLRD PAY',
		cards: {
			one: {
				title: '安全な支払い',
				description:
					'JP WOLRD PAY は、QR コード取引中にお客様の情報を開示しません。',
			},
			two: {
				title: 'どの会社でも',
				description:
					'24 時間いつでもどこでも、オフラインの加盟店で即時安全にお支払いいただけます。',
			},
			three: {
				title: 'タッチフリー',
				description:
					'現金やクレジットカードを気にせず、アプリケーションを開いて支払いましょう。',
			},
		},
	},
	section_free: {
		title_point: 'どこでもショッピングを楽しむ',
		title: '無料で提供いたします',
		title_description: {
			one: 'JP WORLD PAY',
			two: 'は、最高のテクノロジー、最高のサービス、そして最高のプラットフォームをすべて無料でご提供します。',
			three:
				'プレミアム価格を支払うことなく、プレミアム機能を体験してください。初期費用ゼロでビジネスの成長を始めましょう。',
			four: 'シームレスで安全な決済の未来に、今すぐご参加ください。',
		},
		cards: {
			one: {
				title: '理想的な暗号ウォレット',
				description: {
					one: 'JP WOLRD PAYで、ご希望の暗号通貨ウ',
					two: 'ォレットを作成しましょう。',
				},
			},
			two: {
				title: 'より賢く買い物をする',
				description: {
					one: 'ショッピングの際は JP WOLRD PAY',
					two: 'をお選びください。',
				},
			},
			three: {
				title: 'お支払いは当社で',
				description: {
					one: 'JP WOLRD PAYで、ご希望の暗号通貨でお',
					two: '支払いください。',
				},
			},
		},
		button: '無料アカウントを作成する',
	},
	section_world: {
		title_point: '最速の支払いシステム',
		title: {
			one: '世界中どこでも使えます',
			two: '',
		},
		title_description: {
			one: 'JP WOLRD PAYは、クレジットカードを必要とせず、シームレスで柔軟な決済体験を提供します。',
			two: 'オンラインでも実店舗でも、Wi-Fi接続さえあれば、シンプルなQRコードで即座に決済できます。',
			three:
				'JP WOLRD PAYはキオスクやPOS端末を介したオフライン決済もサポートしており、',
			four: 'いつでもどこでも取引を完了できます。カードも手間もかからず、迅速かつ安全な決済が可能です。',
			five: '',
		},
		button: '無料で始める',
	},
	section_member: {
		title_point: 'どこでもショッピングを楽しむ',
		title: 'ビジネス会員は無料',
		title_description: {
			one: 'JP WOLRD PAYはクレジットカードなしでご利用いただけます。',
			two: 'Wi-Fiに接続するだけでQRコードで即座にお支払いいただけます。',
			three:
				'キオスクやPOS端末を利用すれば、オフラインでもご利用いただけます。',
		},
		button: 'ビジネスストアの開設',
	},
};
